/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { GbcarApiConfiguration as __Configuration } from '../gbcar-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ConfigruationResponse } from '../models/configruation-response';
import { GetTableMetadataResponse } from '../models/get-table-metadata-response';
import { GetTableMetadataRequest } from '../models/get-table-metadata-request';
@Injectable({
  providedIn: 'root',
})
class ConfigurationService extends __BaseService {
  static readonly getApiConfigurationPath = '/api/Configuration';
  static readonly postApiConfigurationGetTableMetadataPath = '/api/Configuration/GetTableMetadata';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return Success
   */
  getApiConfigurationResponse(): __Observable<__StrictHttpResponse<ConfigruationResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Configuration`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ConfigruationResponse>;
      })
    );
  }
  /**
   * @return Success
   */
  getApiConfiguration(): __Observable<ConfigruationResponse> {
    return this.getApiConfigurationResponse().pipe(
      __map(_r => _r.body as ConfigruationResponse)
    );
  }

  /**
   * @param body undefined
   * @return Success
   */
  postApiConfigurationGetTableMetadataResponse(body?: GetTableMetadataRequest): __Observable<__StrictHttpResponse<GetTableMetadataResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Configuration/GetTableMetadata`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetTableMetadataResponse>;
      })
    );
  }
  /**
   * @param body undefined
   * @return Success
   */
  postApiConfigurationGetTableMetadata(body?: GetTableMetadataRequest): __Observable<GetTableMetadataResponse> {
    return this.postApiConfigurationGetTableMetadataResponse(body).pipe(
      __map(_r => _r.body as GetTableMetadataResponse)
    );
  }
}

module ConfigurationService {
}

export { ConfigurationService }
